import _cloneDeep from 'lodash/cloneDeep';
import getDeviceFingerprint from '../utils/fingerprint';
import { TParentOptions } from './TreedisPublicDAO';

type APIOptions = {
  baseUrl?: string;
};

export default class API {
  public: any;

  baseUrl: string;

  constructor(options?: APIOptions) {
    this.baseUrl = options?.baseUrl || process.env.NEXT_PUBLIC_API + '/';

    this.public = {
      get: async ({ url = '', ...rest }: any, parentOptions?: TParentOptions) => {
        try {
          if (rest.query) {
            url += `?${this.objectToQueryString(rest.query)}`;
          }

          const config = rest.config ? rest.config : {};
          const headers = _cloneDeep(config.headers || {});

          if (parentOptions?.isFingerprinted) {
            const fingerprint = getDeviceFingerprint();
            headers['x-device-fingerprint'] = fingerprint;
          }

          const results = await fetch(this.baseUrl.concat(url), {
            method: 'get',
            ...rest,
            headers,
          });
          return results.json();
        } catch (err) {
          if (err.code === 422) {
            const errors = Object.values(err?.errors || []);
            errors.map((error: string[]) => console.error(error.join(', ')));
          } else {
            console.error(err.message);
          }
        }
        return null;
      },

      post: async ({ url = '', ...rest }: any, parentOptions?: TParentOptions) => {
        try {
          /** NOTE: FormData can be passed only throw rest.data parameter */
          const data = rest.data ? rest.data : rest;
          const isFormData = rest.data instanceof FormData;

          let body;
          const config = rest.config ? rest.config : {};

          const headers = _cloneDeep(config.headers || {});

          if (parentOptions?.isFingerprinted) {
            const fingerprint = getDeviceFingerprint();
            headers['x-device-fingerprint'] = fingerprint;
          }

          if (isFormData) {
            body = rest.data;
          } else {
            headers['Content-Type'] = 'application/json';
            body = JSON.stringify(data);
          }

          const results = await fetch(this.baseUrl.concat(url), {
            method: 'post',
            headers,
            body,
          });
          return results.json();
        } catch (err) {
          if (!parentOptions?.turnOffToastError) {
            if (err.code === 422) {
              const errors = Object.values(err?.errors || []);
              errors.map((error: string[]) => console.error(error.join(', ')));
            } else {
              console.error(err.message);
            }
          } else return err;
        }
        return null;
      },

      put: async ({ url = '', ...rest }: any) => {
        try {
          const results = await fetch(this.baseUrl.concat(url), {
            method: 'put',
            ...rest,
            ...(rest.data
              ? {
                  body: JSON.stringify(rest.data),
                }
              : {
                  body: JSON.stringify(rest),
                }),
            ...(rest.config
              ? {
                  ...rest.config,
                }
              : {}),
          });
          return results.json();
        } catch (err) {
          if (err.code === 422) {
            const errors = Object.values(err?.errors || []);
            errors.map((error: string[]) => console.error(error.join(', ')));
          } else {
            console.error(err.message);
          }
        }
        return null;
      },

      patch: async ({ url = '', ...rest }: any) => {
        try {
          const results = await fetch(this.baseUrl.concat(url), {
            method: 'PATCH',
            ...rest,
            ...(rest.data
              ? {
                  body: JSON.stringify(rest.data),
                }
              : {
                  body: JSON.stringify(rest),
                }),
            ...(rest.config
              ? {
                  ...rest.config,
                }
              : {}),
          });
          return results.json();
        } catch (err) {
          return err;
        }
      },

      delete: async ({ url = '', ...rest }) => {
        try {
          const results = await fetch(this.baseUrl.concat(url), {
            method: 'delete',
            ...rest,
          });
          return results.json();
        } catch (err) {
          if (err.code === 422) {
            const errors = Object.values(err?.errors || []);
            errors.map((error: string[]) => console.error(error.join(', ')));
          } else {
            console.error(err.message);
          }
        }
        return null;
      },
    };
  }

  // eslint-disable-next-line class-methods-use-this
  private objectToQueryString(obj: any) {
    return Object.keys(obj)
      .map((key) => `${key}=${obj[key]}`)
      .join('&');
  }
}
